<template>
    <div class="rounded-md p-4" :class="classes.background">
        <div class="flex">
            <div class="shrink-0" :class="classes.icon">
                <slot name="icon">
                    <!-- Heroicon name: solid/exclamation -->
                    <svg
                        class="h-5 w-5"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </slot>
            </div>
            <div class="ml-3">
                <h3 class="text-sm font-medium" :class="classes.header">
                    <slot name="title"></slot>
                </h3>
                <div class="mt-2 text-sm" :class="classes.text">
                    <p>
                        <slot name="body"></slot>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const styles = {
    special: {
        background: 'bg-indigo-50',
        icon: 'text-indigo-400',
        header: 'text-indigo-800',
        text: 'text-indigo-700',
    },
    alert: {
        background: 'bg-yellow-50',
        icon: 'text-yellow-400',
        header: 'text-yellow-800',
        text: 'text-yellow-700',
    },
    info: {
        background: 'bg-blue-50',
        icon: 'text-blue-400',
        header: 'text-blue-800',
        text: 'text-blue-700',
    },
};
export default {
    name: 'AlertMessage',
    props: {
        type: {
            required: false,
            default: 'alert',
        },
    },
    data() {
        return {
            classes: styles[this.type],
        };
    },
};
</script>
